// Widget-Raster mit Gruppen (README §5.2) – reine Logik, gilt für Objekt (o) und Einheit (u).

import type { Ausgeblendet, WidgetScope } from './widgetSichtbarkeit';

export type GruppenKey = 'ueb' | 'verm' | 'fin' | 'tech' | 'recht';
export type GruppenFilter = 'alle' | Exclude<GruppenKey, 'ueb'>;

export const GRUPPEN: readonly { key: GruppenKey; label: string }[] = [
  { key: 'ueb', label: 'Übersicht' },
  { key: 'verm', label: 'Vermietung' },
  { key: 'fin', label: 'Finanzen' },
  { key: 'tech', label: 'Technik' },
  { key: 'recht', label: 'Recht & Verwaltung' },
];

export interface WidgetDef<K extends string = string> {
  key: K;
  /** Beschriftung in „Widgets anpassen“ */
  label: string;
  gruppe: GruppenKey;
}

/** Ist das Widget im Raster zu sehen? Im Bearbeiten-Modus immer (README §5.2). */
export function widgetSichtbar(h: Ausgeblendet, scope: WidgetScope, key: string, gruppe: GruppenKey, filter: GruppenFilter, bearbeiten: boolean): boolean {
  if (bearbeiten) return true;
  if (h[scope][key]) return false;
  return filter === 'alle' || filter === gruppe;
}

/** Anzahl sichtbarer (nicht ausgeblendeter) Widgets je Filter – für die Zahlen im Gruppenfilter. */
export function gruppenAnzahl(defs: readonly WidgetDef[], h: Ausgeblendet, scope: WidgetScope, filter: GruppenFilter): number {
  return defs.filter(d => !h[scope][d.key] && (filter === 'alle' || d.gruppe === filter)).length;
}

/** Widgets einer Gruppe in Definitionsreihenfolge, gefiltert nach Sichtbarkeit. */
export function widgetsDerGruppe<D extends WidgetDef>(defs: readonly D[], gruppe: GruppenKey, h: Ausgeblendet, scope: WidgetScope, filter: GruppenFilter, bearbeiten: boolean): D[] {
  return defs.filter(d => d.gruppe === gruppe && widgetSichtbar(h, scope, d.key, gruppe, filter, bearbeiten));
}
